import { NgModule, ModuleWithProviders } from '@angular/core';
import { SessionStorageService } from './session.storage.service';
import { ISessionStorageServiceConfig } from './session.service.config';

@NgModule({
  providers: [
    SessionStorageService
  ]
})
export class SessionStorageModule {
  static withConfig(userConfig: ISessionStorageServiceConfig = {}): ModuleWithProviders {
    return {
      ngModule: SessionStorageModule,
      providers: [
        { provide: 'SESSION_STORAGE_SERVICE_CONFIG', useValue: userConfig }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/common/session.storage.service/session.storage.module.ts